import SplitSidebar from './SplitSidebar';

export default SplitSidebar;
